import {ENV} from '@/interface';
interface EncryptionConfig {
  currentEnv: string | undefined;
  keys: Record<ENV, string>;
  encryptionFlag: boolean;
}
const {
  REACT_APP_ENV,
  REACT_APP_ENCRYPTION_KEY_LOC,
  REACT_APP_ENCRYPTION_KEY_DEV,
  REACT_APP_ENCRYPTION_KEY_QA,
  REACT_APP_ENCRYPTION_KEY_UAT,
  REACT_APP_ENCRYPTION_KEY_PROD,
  REACT_APP_ENCRYPT
} = process.env;

export const ENCRYPTION: EncryptionConfig = {
  currentEnv: REACT_APP_ENV,
  keys: {
    loc: REACT_APP_ENCRYPTION_KEY_LOC as string,
    dev: REACT_APP_ENCRYPTION_KEY_DEV as string,
    prod: REACT_APP_ENCRYPTION_KEY_PROD as string,
    qa: REACT_APP_ENCRYPTION_KEY_QA as string,
    uat: REACT_APP_ENCRYPTION_KEY_UAT as string,
  },

  encryptionFlag: REACT_APP_ENCRYPT === 'TRUE',
};
